import type File from '../../../interfaces/File';

export type FolderPickerListType = 'personal' | 'received' | 'favorites';

/**
 * New folder only in writable personal space (personal list root or owned non-readonly folder).
 * Hidden on virtual root picker, received/favorites, and read-only parents.
 */
export function canCreateFolderInPicker(options: {
  isAtRootLevel: boolean;
  listType: FolderPickerListType;
  /** Current browse parent from getFiles; undefined at personal list root. */
  parentFolder?: Pick<File, 'isReadOnly' | 'ownerId'> | null;
  authenticatedUserId?: number | null;
}): boolean {
  if (options.isAtRootLevel) return false;
  if (options.listType !== 'personal') return false;
  if (options.parentFolder?.isReadOnly) return false;
  if (
    options.parentFolder != null &&
    options.authenticatedUserId != null &&
    options.parentFolder.ownerId != null &&
    options.parentFolder.ownerId !== options.authenticatedUserId
  ) {
    return false;
  }
  return true;
}
